import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useRedux from 'redux/useRedux';
import { AuthVerifyEmail } from 'redux/auth/auth.services';
import { CircularProgress } from '@mui/material';

const VerifyEmail = () => {
    const { thunkDispatch } = useRedux();
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const email = query.get('email');

        if (!email) {
            setStatus('error');
            setMessage('Email wajib diisi');
            return;
        }

        const verify = async () => {
            try {
                const resultAction: any = await thunkDispatch(AuthVerifyEmail(email));
                const response = resultAction.payload;

                if (response && response.status === 'success') {
                    if (response.data?.message === 'Email already verified') {
                        localStorage.clear();
                        sessionStorage.clear();
                        navigate('/login');
                        return;
                    }
                    setStatus('success');
                    setMessage(response.data.message || 'Email berhasil diverifikasi!');
                } else {
                    setStatus('error');
                    setMessage('Email tidak valid');
                }
            } catch (err) {
                setStatus('error');
                setMessage('Email tidak valid');
            }
        };

        verify();
    }, [location.search, thunkDispatch, navigate]);

    return (
        <div className="font-['Inter',-apple-system,sans-serif] bg-slate-50 min-h-screen flex items-center justify-center p-4 sm:p-8 text-slate-900">
            <div className="bg-white w-full max-w-[500px] rounded-xl shadow-[0_10px_25px_-5px_rgba(0,0,0,0.05)] overflow-hidden relative p-10 text-center">
                <img src="https://pagii.co/wp-content/uploads/2023/09/ProductChatshop-VariantDefault-BackgroundLight-1.svg" alt="Chatshop" className="h-[42px] mx-auto mb-8 block" />
                
                {status === 'loading' && (
                    <div className="space-y-4">
                        <CircularProgress color="success" />
                        <p className="text-slate-500">Memverifikasi email Anda...</p>
                    </div>
                )}

                {status === 'success' && (
                    <div className="space-y-6">
                        <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h1 className="text-2xl font-bold text-slate-900">Berhasil!</h1>
                        <p className="text-slate-600">{message}</p>
                        <button 
                            onClick={() => {
                                localStorage.clear();
                                sessionStorage.clear();
                                navigate('/login');
                            }}
                            className="w-full px-6 py-3 font-semibold text-[0.95rem] rounded-md transition-all duration-200 bg-emerald-500 text-white hover:bg-emerald-600 border-none cursor-pointer mt-4"
                        >
                            Masuk Sekarang
                        </button>
                    </div>
                )}

                {status === 'error' && (
                    <div className="space-y-6">
                        <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <h1 className="text-2xl font-bold text-slate-900">Gagal</h1>
                        <p className="text-red-500 font-medium">{message}</p>
                        <button 
                            onClick={() => navigate('/register')}
                            className="w-full px-6 py-3 font-semibold text-[0.95rem] rounded-md transition-all duration-200 bg-slate-100 text-slate-600 hover:bg-slate-200 border-none cursor-pointer mt-4"
                        >
                            Kembali ke Pendaftaran
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;